import { createAction } from 'redux-actions';
import { actionKey } from '../constants';
import { ShippingDestination, ShippingProfile, ShippingRate } from '../types';

export const fetchShippingProfiles = createAction(
  `${actionKey}.FETCH_SHIPPING_PROFILES`,
  () => ({})
);

export const fetchShippingProfilesSuccess = createAction(
  `${actionKey}.FETCH_SHIPPING_PROFILES_SUCCESS`,
  (payload: { profiles: ShippingProfile[] }) => payload
);

export const fetchShippingProfilesError = createAction(
  `${actionKey}.FETCH_SHIPPING_PROFILES_ERROR`,
  () => ({})
);

export const fetchShippingDestinations = createAction(
  `${actionKey}.FETCH_SHIPPING_DESTINATIONS`,
  () => ({})
);

export const fetchShippingDestinationsSuccess = createAction(
  `${actionKey}.FETCH_SHIPPING_DESTINATIONS_SUCCESS`,
  (payload: { destinations: ShippingDestination[] }) => payload
);

export const fetchShippingDestinationsError = createAction(
  `${actionKey}.FETCH_SHIPPING_DESTINATIONS_ERROR`,
  () => ({})
);

export const saveShippingProfile = createAction(
  `${actionKey}.SAVE_SHIPPING_PROFILE`,
  (payload: {
    title: string;
    rates: ShippingRate[];
    profileId?: number;
    onSuccess?: () => void;
    onError?: () => void;
  }) => payload
);

export const saveShippingProfileSuccess = createAction(
  `${actionKey}.SAVE_SHIPPING_PROFILE_SUCCESS`,
  () => ({})
);

export const saveShippingProfileError = createAction(
  `${actionKey}.SAVE_SHIPPING_PROFILE_ERROR`,
  () => ({})
);

export const deleteShippingProfile = createAction(
  `${actionKey}.DELETE_SHIPPING_PROFILE`,
  (payload: { profileId: number; onSuccess?: () => void; onError?: (isInUse?: boolean) => void }) =>
    payload
);

export const deleteShippingProfileSuccess = createAction(
  `${actionKey}.DELETE_SHIPPING_PROFILE_SUCCESS`,
  (payload: { profileId: number }) => payload
);

export const deleteShippingProfileError = createAction(
  `${actionKey}.DELETE_SHIPPING_PROFILE_ERROR`,
  (payload: { profileId: number; isInUse?: boolean }) => payload
);
